import React, { useEffect, useState } from 'react';
import { SimpleTableProps } from './interfaces';
import { useSimpleTable } from './lib/useSimpleTable';
import { TableRow } from './components';
import classNames from 'classnames';
import './SimpleTable.scss';
import dropDownStore from '@widgets/ClientDetails/store/drop-down-table-store';
import dropDownStoreOrder from '@widgets/OrderTable/store/drop-down-table-store';
import { TransactionsTable } from '@widgets/TransactionsTable';
import { AssignPositionTable } from '@widgets/BrokerLevelPositionsTabs/components/AssignPositionTable';

export const SimpleTable: React.FC<SimpleTableProps> = (props) => {
    const { className, noDataLabel = 'Data is Empty', ...rest } = props;

    const { renderedHeader, renderedRows, summaryRow } = useSimpleTable(rest);

    const { rowsOpen } = dropDownStore((state) => state);

    const { orderRowsOpen } = dropDownStoreOrder((state) => state);

    const [showPage, setShowPage] = useState<boolean>();

    const userStorage = localStorage.getItem('User');
    let userObject: any = null;
    userObject = JSON.parse(userStorage ? userStorage : '');

    useEffect(() => {
        if (userObject) {
            setShowPage(true);
        }
    }, []);

    return (
        <table className={classNames('ui-simple-table', className)}>
            <tbody className='ui-simple-table__body'>
                <TableRow
                    dataSet={renderedHeader}
                    isHeader
                />
                {!renderedRows.length && (
                    <tr className='ui-simple-table__no-data'>
                        <td>{noDataLabel}</td>
                    </tr>
                )}
                {renderedRows.map(({ row, rowData }, index) => {
                    const accountId = row[0]?.data as number;
                    let OrderId = 0;
                    let accountId2 = 0;
                    OrderId = row[1]?.data as number;
                    accountId2 = row[2]?.data as number;
                    return (
                        <React.Fragment key={index}>
                            <TableRow
                                key={index}
                                dataSet={row}
                                rowData={rowData}
                            />
                            {props.tableToShow && rowsOpen[accountId] && showPage && (
                                <div>
                                    <AssignPositionTable accountId={accountId} />
                                </div>
                            )}
                            {props.tableToShow && orderRowsOpen[`${accountId2}-${OrderId}`] && (
                                <div className='transaction-table-margin'>
                                    <TransactionsTable orderId={OrderId} />
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
                {!!rest.summary && !!summaryRow && (
                    <TableRow
                        dataSet={summaryRow}
                        rowData={{ className: '2131' }}
                        isHeader
                        isSummary
                    />
                )}
            </tbody>
        </table>
    );
};
